(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    var backLink = event.target.closest('[data-yx-history-back]');
    var hasSameOriginReferrer = false;
    try {
      hasSameOriginReferrer = Boolean(document.referrer)
        && new URL(document.referrer, window.location.href).origin === window.location.origin;
    } catch (_) {
      hasSameOriginReferrer = false;
    }
    if (!backLink || window.history.length <= 1 || !hasSameOriginReferrer) return;

    event.preventDefault();
    window.history.back();
  });
})();
